import axios from 'axios'

const baseURL = ''

const req = axios.create({
    withCredentials: false,
    baseURL,
    timeout:500000
})

export default req


